import { render, staticRenderFns } from "./AddHkiaraceBannerModal.vue?vue&type=template&id=19521b3c"
import script from "./AddHkiaraceBannerModal.vue?vue&type=script&lang=js"
export * from "./AddHkiaraceBannerModal.vue?vue&type=script&lang=js"
import style0 from "./AddHkiaraceBannerModal.vue?vue&type=style&index=0&id=19521b3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports